import pako from "pako";

export const sendCompressedLoginFormData = async (payload: any) => {
  // Step 1: Convert to JSON string
  const jsonStr = JSON.stringify(payload);

  // Step 2: Compress JSON using pako (returns Uint8Array)
  const compressed: any = pako.gzip(jsonStr);

  // Step 3: Create Blob from compressed Uint8Array
  const blob = new Blob([compressed], { type: "application/gzip" });

  // Step 4: Wrap in FormData
  const formData = new FormData();
  formData.append("data", blob, "login.gz");

  // Step 5: Send via Axios
  return formData;
};

export async function sendCompressedFormData(payload: Record<string, any>) {
  const jsonStr = JSON.stringify(payload);
  const compressed = pako.gzip(jsonStr); // Gzip compression
  return compressed
}
